import { Directive, TemplateRef, Input, ElementRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { Funcionalidad } from 'src/app/models/entities/funcionalidad';
import { UsuarioEnSesionService } from 'src/app/services/usuario-en-sesion.service';
import { take, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[validaAcceso]'
})
export class ValidaAccesoDirective implements OnDestroy {

  public sub: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private usuarioEnSesionService: UsuarioEnSesionService
  ) {

  }


  @Input() set validaAcceso(keyFuncionalidad: string) {
    this.sub = this.usuarioEnSesionService.obtenerUsuario()
      .pipe(
        filter((usuarioEnSesionDTO: UsuarioSesionDTO) => usuarioEnSesionDTO !== null)
      )
      .subscribe(
        (usuario: UsuarioSesionDTO) => {
          let elRolTieneLaFuncionalidad: boolean = usuario.funcionalidades.find((f: Funcionalidad) => f.key === keyFuncionalidad) ? true : false;
          if (elRolTieneLaFuncionalidad) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else {
            this.viewContainer.clear();
          }
        }
      );
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }


}
